import React, { Component } from 'react'
const popins = Poppins({weight:"500", subsets:['latin']});
const extraPopins = Poppins({weight: "400", subsets: ['latin']});
import { Poppins } from 'next/font/google'
export default class ParaCon extends Component {
  render() {
    return (
      <>
      <div className="pdt20">
            {/* <h2 className='fs25 mfs18 mfwb600 mpdb5'>{this.props.heading}</h2> */}
            <h3 className={`fs-32 mfs-20  mfwb600 mpdb5 pdb10 ylw-clr ${popins.className}`}>{this.props.heading3}</h3>
            {this.props.content.map((content,i) => {
                return (
                    <div key={i}>
                        <div className={`fs-19 cg mfs14 mlhs20 pdt5 ${extraPopins.className}`}>{content.para}</div>
                    </div>
                )
                 })}
      </div>
      </>
    )
  }
}
